<div class="marker"></div>
<div class="container">
  <!-- Icon -->
  <div class="column">
    <div class="icon-container">
      <app-icon [type]="icon()"
                [width]="16"
                [height]="16"/>
    </div>
  </div>
  <!-- Title and message -->
  <div class="column text-column">
    <h3 class="title">{{ title() }}</h3>
    <p class="message">{{ message() }}</p>
  </div>
  <!-- Close action -->
  <div class="column">
    <button class="close-button"
            app-mini-button
            label="Close notification"
            i18n-label
            (click)="closeToast.emit()">
      <app-icon type="cancel"/>
    </button>
  </div>
</div>